document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-ad-group]').forEach(wrapper => {
        const groupId = wrapper.dataset.adGroup;
        fetch(`/wp-json/fmw-ad/v1/group/${groupId}`)
            .then(r => r.json())
            .then(data => {
                wrapper.innerHTML = data.html || '';
                wrapper.querySelectorAll('script').forEach(s => {
                    const ns = document.createElement('script');
                    if (s.src) ns.src = s.src;
                    else ns.textContent = s.textContent;
                    document.body.appendChild(ns);
                    ns.remove();
                });
            })
            .catch(err => {
                console.error('Ad load failed:', err);
            });
    });
});
